import moment from "moment-timezone";

export const currencyFormate = (value) => {
  const safeValue = value !== undefined && value !== null ? value : 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(safeValue)); // Use Number instead of parseInt
};

export function getDateFromTimestamp(dateInput, format = "MM/DD/YYYY") {
  // Reject null, undefined, empty string, 0, '0'
  if (
    dateInput === null ||
    dateInput === undefined ||
    dateInput === '' ||
    dateInput === 0 ||
    dateInput === '0'
  ) {
    return "--/--/----";
  }

  const userTimeZone = moment.tz.guess();
  let m;

  // Timestamp (ms or seconds)
  if (!isNaN(dateInput)) {
    const num = Number(dateInput);

    // Normalize seconds → milliseconds
    const ts = num < 1e12 ? num * 1000 : num;

    m = moment.tz(ts, userTimeZone);
  } else {
    m = moment.tz(dateInput, userTimeZone);
  }

  if (!m.isValid()) {
    return "--/--/----";
  }

  return m.format(format);
}

export function throttle(callback, delay = 1000) {
  let shouldWait = false;

  return (...args) => {
    if (shouldWait) return;
    callback(...args);
    shouldWait = true;
    setTimeout(() => {
      shouldWait = false;
    }, delay);
  };
}

export const formatTimestamp = (
  timestamp,
  formate = "MM/DD/YYYY - HH:mm:ss z"
) => {
  if (parseInt(timestamp) === 0) {
    return "--/--/----";
  }

  const userTimeZone = moment.tz.guess();

  return moment(timestamp).tz(userTimeZone).format(formate);
};

export const getDayName = (timestamp) => {
  if (parseInt(timestamp) === 0) {
    return "";
  }

  const userTimeZone = moment.tz.guess();

  const date = moment(+timestamp).tz(userTimeZone);

  return date.format("dddd");
};

export const mapPaymentMethod = (methodId) => {
  switch (methodId) {
    case 'shareSellDown':
      return 'Share Sell-Down';
    case 'linkedBankAccount':
      return 'Wallet';
    default:
      return methodId;
  }
}